import React, { useEffect, useState } from 'react';
import { B } from '../constants';
import { promos as promosAPI } from '../api';

export function reelsStats(reels) {
  return [
    { label: 'Active Reels', value: reels.length },
    { label: 'Creator Posts', value: reels.filter(p => p.user?.isInfluencer).length },
    { label: 'Traveller Posts', value: reels.filter(p => !p.user?.isInfluencer).length },
    { label: 'Total Views', value: reels.reduce((s, p) => s + (p.views || 0), 0).toLocaleString() },
  ];
}

export default function ReelsStatsPanel() {
  const [reels, setReels] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    promosAPI.list({ feed: 'ranked' })
      .then(data => { if (!cancelled) setReels(data.promos || []); })
      .catch(err => { if (!cancelled) setError(err.message || 'Failed to load reels'); });
    return () => { cancelled = true; };
  }, []);

  return (
    <section style={{ marginBottom: 32 }}>
      <h2 style={{ fontFamily: "'Playfair Display',serif", color: B.night, fontSize: 22, marginBottom: 12 }}>Reels</h2>
      {error && <p style={{ color: '#c0392b', fontSize: 13 }}>{error}</p>}
      {!error && !reels && <p style={{ color: B.muted, fontSize: 13 }}>Loading reels…</p>}
      {reels && (
        <div className="reels-stats" style={{ display: 'flex', gap: 32, flexWrap: 'wrap', background: '#fff', borderRadius: 12, padding: 16, boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}>
          {reelsStats(reels).map(({ label, value }) => (
            <div key={label}>
              <div style={{ fontFamily: "'Playfair Display',serif", fontSize: 22, fontWeight: 700, color: B.forest }}>{value}</div>
              <div style={{ fontFamily: "'Montserrat',sans-serif", fontSize: 11, color: B.muted, textTransform: 'uppercase', letterSpacing: 1 }}>{label}</div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
